import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function HeroSection() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      title: '深渊之歌',
      subtitle: '在黑暗与光明之间，两个灵魂相遇',
      cta: '立即阅读',
      href: '/comic/comic-001',
      bg: 'https://readdy.ai/api/search-image?query=dark%20romantic%20fantasy%20atmosphere%20with%20two%20male%20silhouettes%20facing%20each%20other%2C%20ethereal%20light%20beams%2C%20swirling%20mist%2C%20dramatic%20composition%2C%20warm%20dark%20amber%20and%20rose%20tones%2C%20artistic%20painterly%20style%2C%20mysterious%20and%20emotional&width=1600&height=700&seq=hero-bg-001&orientation=landscape',
    },
    {
      title: '花间醉',
      subtitle: '花开有声，情深无言',
      cta: '立即阅读',
      href: '/comic/comic-004',
      bg: 'https://readdy.ai/api/search-image?query=ancient%20Korean%20palace%20garden%20at%20sunset%2C%20cherry%20blossoms%20falling%2C%20two%20male%20silhouettes%20in%20traditional%20hanbok%2C%20soft%20golden%20light%2C%20romantic%20historical%20atmosphere%2C%20painterly%20artistic%20style%2C%20warm%20ambient%20tones&width=1600&height=700&seq=hero-bg-002&orientation=landscape',
    },
    {
      title: '那年夏天的风',
      subtitle: '盛夏海风中，两颗心慢慢靠近',
      cta: '立即阅读',
      href: '/comic/comic-002',
      bg: 'https://readdy.ai/api/search-image?query=summer%20seaside%20Korean%20scenery%20at%20sunset%2C%20two%20young%20male%20silhouettes%20walking%20on%20beach%2C%20warm%20golden%20light%2C%20gentle%20waves%2C%20romantic%20youthful%20atmosphere%2C%20soft%20pastel%20warm%20colors%2C%20painterly%20style&width=1600&height=700&seq=hero-bg-003&orientation=landscape',
    },
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <section className="relative h-[420px] md:h-[560px] w-full overflow-hidden">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={slide.bg}
            alt={slide.title}
            className="w-full h-full object-cover object-center"
          />
        </div>
      ))}

      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50" />

      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 w-full">
        <div className="w-full max-w-3xl">
          <p className="text-primary-300 text-sm md:text-base font-medium tracking-widest mb-3 animate-fadeIn">
            专注耽美题材 · 无删减韩国漫画
          </p>
          <h2
            key={currentSlide}
            className="text-3xl md:text-5xl font-heading font-bold text-background-50 mb-3 animate-slideUp"
          >
            {slides[currentSlide].title}
          </h2>
          <p
            key={`sub-${currentSlide}`}
            className="text-lg md:text-xl text-background-200 mb-8 animate-slideUp"
          >
            {slides[currentSlide].subtitle}
          </p>
          <div className="flex items-center justify-center gap-4 flex-wrap">
            <Link
              to={slides[currentSlide].href}
              className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              开始阅读
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/category/all"
              className="inline-flex items-center gap-2 bg-background-50/20 hover:bg-background-50/30 backdrop-blur-sm text-background-50 border border-background-50/30 px-6 py-3 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              浏览全部
              <i className="ri-apps-line"></i>
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
              index === currentSlide
                ? 'bg-primary-500 w-6'
                : 'bg-background-50/50 hover:bg-background-50/80'
            }`}
            aria-label={`切换到第 ${index + 1} 张`}
          />
        ))}
      </div>
    </section>
  );
}